import React from "react";
import { $t } from '@/modules/i18n';

class Theme extends React.Component {
  render() {
    const msg = this.props.Message;
    return (
      <section id="theme">
        <div className="container">
          <div className="title-block">
            <h2>{$t(msg.title)}</h2>
            <div>
              <p>{$t(msg.desc)}</p>
              <img className="image" src={require("@uh/assets/images/" + msg.img)} alt={msg.img} />
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default Theme;